import {
  FieldValues,
  FieldErrors,
  FieldErrorsImpl,
  FieldError,
} from 'react-hook-form';

export const getError = <T extends FieldValues = FieldValues>(
  errors: FieldErrors<T>,
  componentName: string,
): FieldError | undefined => {
  const splitNames: Array<string> = componentName.split('.');
  let res: FieldErrorsImpl<T> | undefined = errors;
  splitNames.forEach((name) => {
    res = res && (res[name] as FieldErrorsImpl<T>);
  });

  return res && 'type' in res && 'message' in res
    ? (res as FieldError)
    : undefined;
};
